import React, { Component } from 'react'

import '../style/navbar.scss'

export default class Navbar extends Component {

    state = {
        isSideMenuOpened: false,
    }

    toggleSideMenu() {
        this.setState({
            ...this.state,
            isSideMenuOpened: !this.state.isSideMenuOpened,
        })
    }

    render() {
        const { isSideMenuOpened } = this.state;

        return (
            <div id="navbar">
                <div className="container">
                    <a href="https://voipdialing.com/">
                        <img className="logo" src={require("../assets/logo.png")} />
                    </a>
                    <div style={{flex: 1}}>
                        <div className="top-nav row">
                            <div><a href="tel:18558342546" target="_blank">855-VDialing (855-834-2546)</a></div>
                            <div><a href="https://voipdialing.com/contactus" /*target="_blank"*/>Contact us</a></div>
                            <div><a href="https://voipdialing.com/contactus/index/about" /*target="_blank"*/>About us</a></div>
                            <div><a href="https://voipdialing.com/contactus/index/faq" /*target="_blank"*/>Faq</a></div>
                            {/*<div><a href="https://voipdialing.com/login">Login</a></div>
                            <div><a href="https://voipdialing.com/register">Register</a></div>*/}
                        </div>
                        <div className="bottom-nav row">
                            <a href="https://voipdialing.com/siptrunks"  /*target="_blank"*/>VoIP Lines</a>
                            <a href="https://voipdialing.com/shop/phone-numbers" /*target="_blank"*/>Phone Numbers</a>
                            <a href="https://voipdialing.com/sms" /*target="_blank"*/>Business SMS</a>
                            <a href="https://voipdialing.com/pbx" /*target="_blank"*/>Hosted PBX</a>
                            {/* <a href="https://voipdialing.com/hospitality" target="_blank">Hospitality Solution</a> */}
                            <a href="https://voipdialing.com/shop" /*target="_blank"*/>Shop</a>
                            {/* <a href="https://voipdialing.com/product-data-sheet" target="_blank">Blog</a> */}
                        </div>
                    </div>
                    <div id="menu-toggle">
                        <i className="fas fa-bars" onClick={() => this.toggleSideMenu()}></i>
                        <div id="menu" className={isSideMenuOpened ? "opened" : ""}>
                            <div id="close-btn" className="menu-btn" onClick={() => this.toggleSideMenu()}>
                                <i className="fas fa-times"></i> <b>Close</b>
                            </div>
                            <a onClick={() => this.toggleSideMenu()} 
                                /*target="_blank"*/ href="https://voipdialing.com/siptrunks" alt="VoIP Lines">
                                <div className="menu-btn">
                                    VoIP Lines
                                </div>
                            </a>
                            <a onClick={() => this.toggleSideMenu()} 
                                /*target="_blank"*/ href="https://voipdialing.com/did" alt="Phone Numbers">
                                <div className="menu-btn">
                                    Phone Numbers
                                </div>
                            </a>
                            <a onClick={() => this.toggleSideMenu()} 
                                /*target="_blank"*/ href="https://voipdialing.com/sms" alt="SMS">
                                <div className="menu-btn">
                                    SMS
                                </div>
                            </a>
                            <a onClick={() => this.toggleSideMenu()} 
                                /*target="_blank"*/ href="https://voipdialing.com/pbx" alt="Hosted PBX">
                                <div className="menu-btn">
                                    Hosted PBX
                                </div>
                            </a>
                            <a onClick={() => this.toggleSideMenu()} 
                                /*target="_blank"*/ href="https://voipdialing.com/shop" alt="Shop">
                                <div className="menu-btn">
                                    Shop
                                </div>
                            </a>
                            <a onClick={() => this.toggleSideMenu()} 
                                /*target="_blank"*/ href="https://voipdialing.com/contactus" alt="Contact Us">
                                <div className="menu-btn">
                                    Contact Us
                                </div>
                            </a>
                            <a onClick={() => this.toggleSideMenu()} 
                                /*target="_blank"*/ href="https://voipdialing.com/contactus/index/about" alt="About">
                                <div className="menu-btn">
                                    About Us
                                </div>
                            </a>
                            <a onClick={() => this.toggleSideMenu()} 
                                /*target="_blank"*/ href="https://voipdialing.com/contactus/index/faq" alt="Faq">
                                <div className="menu-btn">
                                    Faq
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
